







import { Component, Vue, Watch } from "vue-property-decorator";
// import editAccountDialog from './editAccount.vue'
import { Getter } from "vuex-class";

@Component({
  components: {
    // editAccountDialog
  }
})
export default class Dialogs extends Vue {
  @Getter("nav/dialogs") public dialogs: any;
  // @Action('nav/showDialog') showDialog:any;

  // onInput(v){

  // }

  // created () {
  //   setInterval(()=>{
  //     log(this.dialogs)
  //   },2000)
  // }
}
